<template>
  <div id="top">
	<!-- <banner :bannerUrl="bannerUrl"></banner> -->
    <section class="hero-area">
<div class="hero-slider">
    <div class="breadcrumbs overlay" :style="{backgroundImage: 'url(' + require('../assets/images/banner01.jpg') + ')' }">
<div class="container">
<div class="row align-items-center">
<div class="col-lg-8 offset-lg-2 col-md-12 col-12">
<div class="breadcrumbs-content">
<h1 class="page-title">{{ $t("banners.registration.h1Content") }}</h1>
<!-- <p>2024第二届储能与智慧电站关键技术论坛以“智慧赋能 驱动未来”为主题，将于2024年10月18日至10月20日<br>在天津水游城丽筠酒店召开。</p> -->
<p>{{ $t("banners.registration.content") }}</p>
</div>
<ul class="breadcrumb-nav">
<li><a style="cursor:pointer" @click="goToIndex()">{{ $t("banners.registration.button[0]") }}</a></li>
<li>{{ $t("banners.registration.button[1]") }}</li>
</ul>
</div>
</div>
</div>
</div>
</div>  
</section>

<section class="section blog-single" v-if="this.$i18n.locale == 'zh'">
<div class="container">
<div class="row">
<div class="col-lg-10 offset-lg-1 col-md-12 col-12">
<div class="single-inner">

<div class="post-details">
<div class="detail-inner">

<ul class="custom-flex post-meta">
<li>
<a href="javascript:void(0)">
<i class="lni lni-calendar"></i>
2026年09月20日
</a>
</li>
</ul>
<h2 class="post-title" style="text-align: center;">
<a href="javascript:void(0)" >关于举办“2026第四届储能与智慧电站关键技术研讨会”的会议通知 </a>
<a href="javascript:void(0)" style="font-size: 14px;" >（暨亚行TA10637-PRC：小水电生态产品价值实现机制与绿色转型关键技术研究与示范项目-第二次技术研讨会）</a>
</h2>
<p>各有关单位：
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为深入贯彻落实国家“双碳”战略部署，加快新型电力系统构建，大力培育能源领域新质生产力，持续推进储能与智慧电站领域技术迭代创新，促进绿色能源高效消纳、智能运维升级与跨主体产业协同，推动我国新能源产业高质量发展。2026第四届储能与智慧电站关键技术研讨会暨亚行TA 10637‑PRC：小水电生态产品价值实现机制与绿色转型关键技术研究与示范项目‑第二次技术研讨会以“绿能智运，协调协同”为主题，定于2026年10月23-25日在天津静海举办。

<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次会议同步承担亚行TA10637‑PRC 技术援助项目第二次技术研讨任务。该亚行项目聚焦我国小水电绿色转型发展，围绕小水电生态产品价值核算、价值实现路径、补偿与交易机制开展研究，探索存量小水电改造升级、水‑风光储多能协同运行关键技术，依托典型区域开展工程示范，着力形成可复制推广的技术方案与政策建议，助力国内小水电行业提质升级，也为亚太地区小水电可持续发展提供实践参考。
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次会议致力于搭建储能技术、智慧电站、新能源协同调度领域集学术研讨、技术创新、产业对接于一体的高水平交流平台。会议将汇聚国内高校科研院所、发电集团、电力装备龙头企业的知名专家与一线工程技术骨干，同时邀请亚行项目研究团队、水利行业专家参会。针对储能系统优化配置、智慧电站工程建设、多类型新能源协同调度、智能运维关键技术攻关、行业标准规范完善、创新技术产业化落地应用等行业热点与难点问题开展交流研讨，集中展示分享前沿学术成果、创新技术方案以及典型工程实践经验，助力打通技术从研发到落地的链路，促进行业经验互鉴、技术共创与产业协同发展。
</p>
<h3>一、会议信息</h3>
<ul class="list">
<li><i class="lni lni-chevron-right-circle"></i>会议官网：https://ices.tj.cn/</li>
<li><i class="lni lni-chevron-right-circle"></i>大会时间：2026年10月24-10月25日</li>
<li><i class="lni lni-chevron-right-circle"></i>会议地点：天津光合谷开元名都温泉度假酒店</li>
</ul>
<p></p>

<h3>二、组织机构</h3>
<p><a class="sub_title">主办单位：</a>天津仁爱学院<br>
  <a class="sub_title">承办单位：</a>天津天发总厂机电设备有限公司<br>
  <a class="sub_title"></a>天津仁爱学院绿色水电研究院<br>
    <a class="sub_title">支持单位：</a>国际小水电中心<br>
  <a class="sub_title"></a>纳睿国际咨询有限公司<br>
  <a class="sub_title">协办单位</a>中国电器工业协会水电设备分会<br>
  <a class="sub_title"></a>中国水力发电工程学会继电保护与励磁专业委员会<br>
  <a class="sub_title"></a>能源行业小水电机组标准化技术委员会<br>
  <a class="sub_title"></a>全国水轮机标准化技术委员会<br>
  <a class="sub_title"></a>控制设备分技术委员会<br>
  <a class="sub_title"></a>天津市机械工程学会<br>
  <a class="sub_title"></a>河北省水力发电工程学会<br>
  <a class="sub_title">支持媒体：</a>《机械设计》杂志社<br>
  <a class="sub_title"></a>凤凰网<br>
</p>
<h3>三、专家委员会</h3>
<p>会议学术委员会：<br>
 张俊红、王正伟、陈小明、王莹、郭伟、孙江<br>
  会议组委会：<br>
  1、会议主席：孙江<br>
  2、技术方案委员会：张俊红、郭伟<br>
  3、组织委员会：张静、刘金剑、石丽雯、李磊<br>
  4、出版主席：王莹<br>
</p>
<h3>四、日程简表：</h3>
<p>
    <!-- 1、王成山院士团队报告《储能运行控制问题与工程实践》<br>
    2、清华大学 王正伟 教授《水力机械及系统多场耦合》<br>
    3、北京航空航天大学 刘继红 教授《工业智能技术及其应用》<br>
    4、天津仁爱学院 孙江 教授《大型灯泡贯流机组性能检测和再制造关键技术与应用》<br>
    5、长江电力股份有限公司科学技术研究中心 主任研究员 周志军《水轮机控制系统数字孪生关键技术应用》<br>
    6、中国长江三峡集团上海勘测设计研究院有限公司高级工程师 李彦浩《新型电力系统下的抽水蓄能电站灵活运行发展前景和关键技术展望》<br>
    7、中国大唐集团“首届青年拔尖人才”正高级工程师 张海库《水电领域设备技术创新研究进展》<br>
    8、国家能源局华北监管局相关领导做行业政策解读报告<br>
    日程简表：<br> -->
    <table>
      <thead>
            <tr>
                <th colspan="2">日期</th>
                <th>内容</th>
            </tr>
        </thead>
        <tbody>
            <!-- 第1行 -->
            <tr>
                <td>10.23（周五）</td>
                <td>14:00-22:00</td>
                <td>大会报到</td>
            </tr>
            <!-- 第2行 -->
            <tr>
                <td rowspan="3">10.24（周六）</td>
                <td rowspan="2">9:00-12:00</td>
                <td style="border-bottom: 0;">开幕式</td>
            </tr>
            <!-- 第2行 -->
            <tr>
              <td style="border-top: 0;">大会报告</td>
            </tr>
            <tr>
              <td >14:00-17:30</td>
              <td >大会报告</td>
            </tr>
            <tr>
                <td rowspan="3">10.25（周日）</td>
                <td >10:00-11:00</td>
                <td >亚行项目培训会</td>
            </tr>
            <tr>
                <td >11:00-12:00</td>
                <td >参观企业</td>
            </tr>
            <tr>
                <td >下午</td>
                <td >离 会</td>
            </tr>
        </tbody>
    </table>
</p>
<h3>五、注册及会务费用</h3>
<p>1、注册会务费1500元/人，包含会议当日用餐，参会交通及食宿费用自理。<br>
  2、会务公司协办开具发票，汇款可以通过银行对公转账或扫码方式进行，汇款信息如下：<br>
  <i class="lni lni-chevron-right-circle"></i><span style="margin-left: 5px;line-height: 30px;">公司名称：和丰（天津）管理咨询有限公司</span><br>
  <i class="lni lni-chevron-right-circle"></i><span style="margin-left: 5px;line-height: 30px;">开户行名称：兴业银行天津金纬路支行</span><br>
  <i class="lni lni-chevron-right-circle"></i><span style="margin-left: 5px;line-height: 30px;">银行账号：441180100100251776</span><br>
  <span style="margin-left: 30px;"><img src="../assets/images/pay.png" /></span><br>
  <span style="margin-left: 30px;color: #87ceeb;border-bottom: 1px solid;">注：扫码付款时请务必注明“单位简称+姓名”，并将付款凭证发至icestj@126.com。</span><br>
  3、报名联系方式<br>
 请参会代表于 2026年10月9日前通过下方二维码进行报名或填写<报名回执表>盖章扫描发送至icestj@126.com(附件1)，会务组提前七天发送会议指南到各参会人员，详告报到路线等其他会务事项。<br>
  <i class="lni lni-chevron-right-circle"></i><a class="sub_title1">会议联系人：</a>尹老师  电话：13920977534<br>
  <a class="sub_title1"></a>石老师  电话：13821029229<br>
  <span style="margin-top: 10px;display: inline-block;"><img style="vertical-align: text-bottom;" src="../assets/images/tianbao.png" /><p style="vertical-align: text-bottom;text-align: center;font-weight: 700;"> 报名填报二维码  </p> </span>
  <span style="margin-top: 10px;display: inline-block;margin-left: 20px;"><img style="vertical-align: text-bottom;" src="../assets/images/wechatMany.png" /><p style="vertical-align: text-bottom;text-align: center;font-weight: 700;"> 参会人员微信大群</br>（此二维码入群9月30日前有效，失效后请联系会务人员入群）  </p> </span>


 

</p>
<p>感谢您对本次大会的关注和支持，我们将对您的到来表示衷心的感谢与欢迎!</p>

<div class="post-tags-media">
<div class="post-tags popular-tag-widget mb-xl-40">
    <p class="share-title"><a  style="color: red;border-bottom: 1px solid;cursor: pointer;" @click="downLoadFile('会议通知.pdf')">附件： 会议通知.pdf</a></p>
    <p class="share-title"><a  style="color: red;border-bottom: 1px solid;cursor: pointer;" @click="downLoadFile('附件-报名回执表.docx')">附件： 报名回执表.docx</a></p>

</div>
<div class="post-social-media">


</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="section blog-single" v-if="this.$i18n.locale == 'en'">
<div class="container">
<div class="row">
<div class="col-lg-10 offset-lg-1 col-md-12 col-12">
<div class="single-inner">

<div class="post-details">
<div class="detail-inner">

<ul class="custom-flex post-meta">
<li>
<a href="javascript:void(0)">
<!-- <i class="lni lni-calendar"></i> -->
</a>
</li>
</ul>
<h2 class="post-title" style="text-align: center;">
<a href="javascript:void(0)" >Coming soon……</a>
</h2>
</div>
</div>
</div>
</div>
</div>
</div>
</section>



 

<a href="javascript:void(0)" class="scroll-top btn-hover" @click="scrollToAnchor('top')">
<i class="lni lni-chevron-up"></i>
</a>
  </div>
</template>
  
<script>
import indexnav from "@/components/nav/indexnav.vue";
import banner from "@/components/header/banner.vue";

export default {
  name: "RegisterMetting",
  components: {
    indexnav,
    banner,
  },
  data() {
    return {
      bannerUrl: ["BANNER.png"],
    };
  },
  mounted() {
    //  TouchSlide({
    // 		slideCell:"#news_slide",
    // 		mainCell:".bd ul",
    // 		effect:"leftLoop",
    // 		autoPlay:true//自动播放
    //  });
    const slide = document.querySelector(".hero-slider");
    console.log(slide);
    tns({
      container: ".hero-slider",
      items: 1,
      slideBy: "page",
      autoplay: false,
      mouseDrag: true,
      gutter: 0,
      nav: true,
      controls: false,
      controlsText: [
        '<i class="lni lni-arrow-left"></i>',
        '<i class="lni lni-arrow-right"></i>',
      ],
    });

    document.addEventListener("click", (evnt) => {
      let anchor = evnt.target.closest('a[href^="#"]');
      if (anchor) {
        evnt.preventDefault();
        let value = anchor.getAttribute("set_data");
        if (value) {
          this.newsDetail(value);
        }
      }
    });
  },
  methods: {
    downLoadFile(fileName) {
      const fileUrl = "/img/" + fileName;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      link.click();
    },
    goToIndex() {
      this.$router.push({
        path: "/index",
      });
    },
    scrollToAnchor(id) {
      var anchor = document.getElementById(id);
      anchor.scrollIntoView();
    },
    newsDetail(index) {
      console.log(11111);
      this.$router.push({
        path: "/newsDetail/" + index,
      });
    },
    caseDetail(type) {
      this.$router.push({
        path: "/caseDetail/" + type,
      });
    },
  },
};
</script>
  
<style>
.sub_title {
  display: inline-block;
  width: 75px;
  color: #888;
}
.sub_title1 {
  display: inline-block;
  width: 90px;
  color: #888;
  margin-left: 5px;
}
table {
  width: 400px;
  margin-left: 30px;
  border: 1px solid #000000;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #000000;
  text-align: center;
}
</style>